import apiService from './api';

const nursingCareCatalogService = {
  getTypes(params = {}) {
    return apiService.get('/nursing-care-catalog/types', { params });
  },

  list(params = {}) {
    return apiService.get('/nursing-care-catalog', { params });
  },

  getById(id) {
    return apiService.get(`/nursing-care-catalog/${id}`);
  },

  create(payload) {
    return apiService.post('/nursing-care-catalog', payload);
  },

  update(id, payload) {
    return apiService.put(`/nursing-care-catalog/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/nursing-care-catalog/${id}`);
  }
};

export default nursingCareCatalogService;
